<div class="chat-modal-msg">
    <div class="chat-modal-msg-avatar-holder">
        <app-avatar
            [user]="message.user"
            [fontSize]="'8px'"
            [fontWeight]="'300'"
            [showIcons]="false"></app-avatar>
    </div>
    <img
        *ngIf="message.type === 'file'"
        class="message-image"
        [src]="getPathToFile(message.content)" />
    <div
        *ngIf="message.type === 'chat' || message.type === 'subject'"
        class="chat-modal-msg-mgs-holder">
        <span [innerHtml]="message.content"></span>
    </div>
</div>
